/** Champs et onglets de la fiche collaborateur qu'une synchro API peut alimenter (clés back). */
export const EMPLOYEE_SYNCED_FIELDS: { key: string; label: string }[] = [
  { key: "first_name", label: "Prénom" },
  { key: "last_name", label: "Nom" },
  { key: "email", label: "Email" },
  { key: "phone", label: "Téléphone professionnel" },
  { key: "phone_personnal", label: "Téléphone personnel" },
  { key: "birthday", label: "Date de naissance" },
  { key: "address", label: "Adresse" },
  { key: "avatar", label: "Photo" },
  { key: "status", label: "Statut actif / inactif" },
  { key: "is_employed", label: "Collaborateur salarié" },
  { key: "tags_ids", label: "Étiquettes" },
  { key: "tab:POSITIONS", label: "Onglet Positions" },
];

/**
 * Préférences société du module Collaborateurs (Paramètres collaborateurs) :
 * suivi des soldes de congés / heures supplémentaires, et champs gérés par une synchro API
 * (lecture seule dans l'interface).
 */
export class EvaCompanyEmployeesConfig {
  is_vacation_balance_tracked: boolean = true;
  is_overtime_balance_tracked: boolean = true;
  synced_fields: string[] = [];

  public static createInstance(jsonData: any): EvaCompanyEmployeesConfig {
    return Object.assign(new EvaCompanyEmployeesConfig(), jsonData ?? {});
  }

  isSynced(key: string): boolean {
    return this.synced_fields.includes(key);
  }
}
